import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { FeatureValues, } from '@models';
import { FeaturesService } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var FeatureflagsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureflagsModalComponent, _super);
    function FeatureflagsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.FeatureValues = FeatureValues;
        _this.loading$ = new BehaviorSubject(false);
        _this._featuresService = _this._injector.get(FeaturesService);
        return _this;
    }
    Object.defineProperty(FeatureflagsModalComponent.prototype, "featureKeys", {
        get: function () {
            return Object.keys(this.form.controls);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeatureflagsModalComponent.prototype, "features", {
        get: function () {
            return this.context.data.features;
        },
        enumerable: true,
        configurable: true
    });
    FeatureflagsModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var fb = this._injector.get(FormBuilder);
        var formControls = Object.keys(this.context.data.features)
            .reduce(function (acc, featureName) {
            if (_this.context.data.features[featureName] != null) {
                acc[featureName] = [{ value: _this.context.data.features[featureName].value,
                        disabled: !!_this.context.data.features[featureName].notEditable }];
            }
            return acc;
        }, {});
        this.form = fb.group(formControls);
    };
    FeatureflagsModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.dirty ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        this._saveFeatureFlags()
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            _this._dialogRef.close({
                type: 2 /* Update */,
            });
        });
    };
    FeatureflagsModalComponent.prototype._saveFeatureFlags = function () {
        var _this = this;
        var payload = cloneDeep(this.form.value);
        this.featureKeys
            .forEach(function (controlKey) {
            if (!_this.form.get([controlKey]).dirty) {
                delete payload[controlKey];
            }
        });
        return this._featuresService.updateFeatureFlags(payload, this.context.data.tenantIds);
    };
    return FeatureflagsModalComponent;
}(UiModalComponent));
export { FeatureflagsModalComponent };
